var map = {
	"./andry--default.svg": "74c7",
	"./andry--pressed.svg": "6e83",
	"./happy--default.svg": "b563",
	"./happy--pressed.svg": "6975",
	"./neutral--default.svg": "4b5b",
	"./neutral--pressed.svg": "3e7d",
	"./sad--default.svg": "8d14",
	"./sad--pressed.svg": "a36b",
	"./smile--default.svg": "ad5b",
	"./smile--pressed.svg": "97ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c3e";